import { render } from "./VSpinner.vue?vue&type=template&id=7cf4e94c&scoped=true"
import script from "./VSpinner.vue?vue&type=script&lang=js"
export * from "./VSpinner.vue?vue&type=script&lang=js"

import "./VSpinner.vue?vue&type=style&index=0&id=7cf4e94c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf4e94c"]])

export default __exports__